// @ts-nocheck
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddLinesToCart";

replaceInChain(chain, PopulateApiParameter, props => {
    props.apiParameter = props.parameter.apiParameter;

    props.apiParameter.cartLineCollection?.cartLines?.forEach((line, index) => {
        if (line.properties && "isOnRestrictedBuyingList" in line.properties) {
            const { isOnRestrictedBuyingList, ...restProperties } = line.properties;
            props.apiParameter.cartLineCollection!.cartLines![index] = {
                ...line,
                properties: restProperties,
            };
        }
    });
});
